import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import HtmlImg from "../../../assets/HTML.svg";
import CssImg from "../../../assets/CSS.svg";
import BootstapImg from "../../../assets/Bootstrap.svg";
import TailwindImg from "../../../assets/Tailwind.svg";
import RouterImg from "../../../assets/Router.png";
import JsImg from "../../../assets/JS.svg";
import ReactImg from "../../../assets/React.svg";
import MongoDbImg from "../../../assets/MongoDb.png";
import MongooseImg from "../../../assets/download.png";
import GithubImg from "../../../assets/Github.png";
import GitImg from "../../../assets/Git.svg";
import VSImg from "../../../assets/Vs_Code.svg";
import VercelImg from "../../../assets/vercel.png";
import FirebaseImg from "../../../assets/Firebase.png";
import NodeImg from "../../../assets/NodeJs.png";
import ExpressImg from "../../../assets/Express.png";

const TechStack = () => {
  return (
    <div className="tech pb-5">
      <Container className="max-w-[1200px] mt-5">
        <h2 className="text-center banner-text font-bold mb-4">My Skills</h2>
        <p className="text-center text-gray-600 mb-5">
          Adept in leveraging a diverse skill set to craft seamless and engaging
          digital experiences, ensuring user-centric designs and intuitive
          interfaces.
        </p>

        {/* Expert Section */}
        <div className="mb-5">
          <h2 className="text-center banner-text font-bold mb-5">Expert</h2>
          <Row className="justify-content-center align-items-center">
            <TechImage imgSrc={HtmlImg} altText="HTML" />
            <TechImage imgSrc={CssImg} altText="CSS" />
            <TechImage imgSrc={BootstapImg} altText="Bootstrap" />
            <TechImage imgSrc={TailwindImg} altText="Tailwind" />
            <TechImage imgSrc={RouterImg} altText="Router" rounded />
            <TechImage imgSrc={JsImg} altText="JavaScript" />
            <TechImage imgSrc={ReactImg} altText="React" />
          </Row>
        </div>

        {/* Familiar Section */}
        <div className="mb-5">
          <h2 className="text-center banner-text font-bold mb-5">Familiar</h2>
          <Row className="justify-content-center align-items-center">
            <TechImage imgSrc={MongoDbImg} altText="MongoDB" />
            <TechImage imgSrc={MongooseImg} altText="Mongoose" />
            <TechImage imgSrc={NodeImg} altText="Node.js" />
            <TechImage imgSrc={ExpressImg} altText="Express" />
            <TechImage imgSrc={FirebaseImg} altText="Firebase" />
          </Row>
        </div>

        {/* Tools Section */}
        <div>
          <h2 className="text-center banner-text font-bold mb-5">Tools</h2>
          <Row className="justify-content-center align-items-center">
            <TechImage imgSrc={GitImg} altText="Git" />
            <TechImage imgSrc={VSImg} altText="VS Code" />
            <TechImage imgSrc={VercelImg} altText="Vercel" rounded />
            <TechImage imgSrc={GithubImg} altText="GitHub" rounded whiteBg />
          </Row>
        </div>
      </Container>
    </div>
  );
};

// Reusable component for displaying images
const TechImage = ({ imgSrc, altText, rounded, whiteBg }) => {
  const style = {
    maxWidth: "70px",
    borderRadius: rounded ? "50%" : "0",
    backgroundColor: whiteBg ? "#fff" : "transparent",
    padding: whiteBg ? "5px" : "0",
    margin: "5px",
  };

  return (
    <Col className="text-center">
      <Image src={imgSrc} alt={altText} style={style} />
    </Col>
  );
};

export default TechStack;
